import { useState } from 'react';
import { OnboardingProgressPanel } from './OnboardingProgressPanel.js';
import { WorkflowHistoryPanel } from './WorkflowHistoryPanel.js';

type Tab = 'self' | 'system';

export function OnboardingPanel({
  userId,
  isArchived,
  autoExpand = false,
}: {
  userId: number;
  isArchived: boolean;
  autoExpand?: boolean;
}) {
  const [tab, setTab] = useState<Tab>(autoExpand ? 'system' : 'self');

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div className="flex border-b border-gray-200">
        <TabButton active={tab === 'self'} onClick={() => setTab('self')}>
          Self Onboarding progress
        </TabButton>
        <TabButton active={tab === 'system'} onClick={() => setTab('system')}>
          System Onboarding progress
        </TabButton>
      </div>
      <div className="p-6">
        {tab === 'self' ? (
          <OnboardingProgressPanel userId={userId} embedded />
        ) : (
          <WorkflowHistoryPanel
            userId={userId}
            isArchived={isArchived}
            autoExpand={autoExpand}
            embedded
          />
        )}
      </div>
    </div>
  );
}

function TabButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-6 py-3 text-sm font-medium border-b-2 -mb-px transition-colors ${
        active
          ? 'border-primary-600 text-primary-700'
          : 'border-transparent text-gray-500 hover:text-gray-700'
      }`}
    >
      {children}
    </button>
  );
}
